import { ModelTypes } from '@zeus';
import { bindable } from 'aurelia';

export class FlowCardComponent {
  @bindable deal: ModelTypes['deal'];
}